import { useRef } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

interface ReCaptchaWrapperProps {
    onVerify: (token: string | null) => void
    onExpire?: () => void
}

export const ReCaptchaWrapper: React.FC<ReCaptchaWrapperProps> = ({ onVerify, onExpire }) => {
    const recaptchaRef = useRef<ReCAPTCHA>(null)

    return (
        <div className="recaptcha-container">
            <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                onChange={onVerify}
                onExpired={onExpire}
            />
        </div>
    )
}
